import { SendEventProps } from '../../interface/biEvents';

export const mpDescriptionClicked = () =>
    ({
        eventName: 'Gig page - Seller card - Description clicked',
    } satisfies SendEventProps);
